var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRichtextToggle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.10527V2C0 0.895431 0.895432 0 2 0H25.3684C26.473 0 27.3684 0.895428 27.3684 2V4.10526C27.3684 5.20983 26.473 6.10526 25.3684 6.10526H16.8421V21.0596C16.8421 21.4002 16.7551 21.7351 16.5895 22.0327L12.007 30.2617C11.916 30.4251 11.7438 30.5263 11.5568 30.5263C10.9877 30.5263 10.5263 30.0649 10.5263 29.4958V6.10526H2C0.895431 6.10526 0 5.20984 0 4.10527Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4711 27.5444C27.1679 27.8731 26.677 27.9334 26.2889 27.7112L21.2284 24.8139C20.8359 24.5892 20.6399 24.1282 20.7778 23.6976C21.2865 22.1088 22.1072 20.4495 23.2396 18.7229C24.9256 16.1469 27.9416 11.7481 32.2858 5.52718C33.254 4.1402 35.1717 3.79366 36.5691 4.75314C37.8073 5.60327 38.2429 7.21781 37.5986 8.5689C34.3339 15.4219 32.0021 20.2109 30.5993 22.9352C29.6538 24.7722 28.611 26.3086 27.4711 27.5444ZM18.9262 27.4276L25.152 30.9907L23.734 34.7247L15.7895 40L16.3738 30.5107L18.9262 27.4276Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRichtextToggle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/richtext-toggle.461d3720b843ab2a12cb7ffab7aa596e.svg";